import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { StrategyChildrenCard } from "./card";
import { setDocumentTitle } from "@/lib/documentTitle";

import { StrategyChildrenTable } from "./table";

export default function StrategyChildren() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Enfants de stratégie");
  }, []);

  return (
    <Routes>
      <Route index element={<StrategyChildrenTable />} />

      <Route path=":id" element={<StrategyChildrenCard />} />
    </Routes>
  );
}
